var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_c('router-view'),_c('loading',{attrs:{"loadingFlag":_vm.loadingFlag}}),_c('notification'),_c('narrativeCard'),_c('presentationCard'),_c('presentationLandingCard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }